/* =========================================================
   Flowa Landing Theme — theme.js
   ========================================================= */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var theme = window.theme || { routes: {}, strings: {}, settings: {} };
  theme.settings = theme.settings || {};

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  /* ---------------- Drawers ---------------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var close = $('.drawer__close', d);
    if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('drawer-open');
  }
  theme.openDrawer = openDrawer;
  theme.closeDrawers = closeDrawers;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && (document.body.classList.contains('template-cart') || !document.getElementById('CartDrawer'))) return;
      e.preventDefault();
      openDrawer(id);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- Cart ---------------- */
  var Cart = {
    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    },
    refresh: function (open) {
      var url = (theme.routes.cart || '/cart') + '?sections=cart-drawer';
      return Promise.all([
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
        fetch((theme.routes.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      ]).then(function (res) {
        var html = res[0] && res[0]['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartDrawer-Inner');
          var current = document.getElementById('CartDrawer-Inner');
          if (fresh && current) current.replaceWith(fresh);
        }
        Cart.updateCount(res[1].item_count);
        var drawer = document.getElementById('CartDrawer');
        if (drawer) drawer.classList.remove('is-loading');
        if (open) openDrawer('CartDrawer');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res[1] }));
      });
    },
    change: function (line, quantity) {
      var drawer = document.getElementById('CartDrawer');
      if (drawer) drawer.classList.add('is-loading');
      return fetch((theme.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { return Cart.refresh(false); });
    }
  };
  theme.cart = Cart;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CartDrawer [data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('[data-line]');
    if (!item) return;
    Cart.change(parseInt(item.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-cart-qty'), 10));
  });

  /* ---------------- Product ---------------- */
  function ProductSection(el) {
    this.el = el;
    var json = $('[data-product-json]', el);
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    this.form = $('[data-product-form]', el);
    this.variantInput = $('[data-variant-input]', el);
    this.qtyInput = $('[data-quantity-input]', el);
    this.bundle = $('[data-bundle]', el);
    var self = this;
    var initialId = this.variantInput ? String(this.variantInput.value) : null;
    this.variant = this.product.variants.filter(function (v) { return String(v.id) === initialId; })[0] || this.product.variants[0];

    this.initGallery();
    this.initVariants();
    this.initBundle();
    this.initQty();
    this.initForm();
    this.initSticky();
    el._product = self;
  }

  ProductSection.prototype.initGallery = function () {
    var track = $('[data-gallery-track]', this.el);
    if (!track) return;
    var self = this;
    this.track = track;
    this.slides = $$('.gallery__slide', track);
    var go = function (i) {
      i = Math.max(0, Math.min(self.slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    };
    this.goTo = go;
    var setActive = function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === self.activeIndex) return;
      self.activeIndex = i;
      $$('[data-gallery-go]', self.el).forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-gallery-go'), 10) === i);
      });
      var thumbs = $('[data-gallery-thumbs]', self.el);
      var activeThumb = thumbs && $('.gallery__thumb.is-active', thumbs);
      if (activeThumb) thumbs.scrollTo({ left: activeThumb.offsetLeft - thumbs.clientWidth / 2 + activeThumb.clientWidth / 2, behavior: 'smooth' });
      self.slides.forEach(function (s, idx) {
        if (idx !== i) $$('video', s).forEach(function (v) { v.pause(); });
      });
    };
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(setActive, 60); }, { passive: true });
    this.el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gallery-go]');
      if (b && self.el.contains(b)) { go(parseInt(b.getAttribute('data-gallery-go'), 10)); return; }
      if (e.target.closest('[data-gallery-prev]')) go((self.activeIndex || 0) - 1);
      if (e.target.closest('[data-gallery-next]')) go((self.activeIndex || 0) + 1);
    });
    this.activeIndex = 0;
  };

  ProductSection.prototype.goToMedia = function (mediaId) {
    if (!this.slides) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) { this.goTo(i); break; }
    }
  };

  ProductSection.prototype.initVariants = function () {
    var picker = $('[data-variant-picker]', this.el);
    if (!picker) return;
    var self = this;
    picker.addEventListener('change', function () {
      var opts = [];
      $$('select[data-option-index]', picker).forEach(function (s) { opts[+s.getAttribute('data-option-index')] = s.value; });
      $$('input[data-option-index]:checked', picker).forEach(function (i) { opts[+i.getAttribute('data-option-index')] = i.value; });
      opts.forEach(function (val, idx) {
        var label = $('[data-option-label="' + idx + '"]', picker);
        if (label) label.textContent = val;
      });
      var match = self.product.variants.filter(function (v) {
        return v.options.every(function (o, idx) { return o === opts[idx]; });
      })[0];
      self.setVariant(match);
    });
  };

  ProductSection.prototype.setVariant = function (v) {
    var el = this.el;
    var buttons = $$('[data-atc], [data-sticky-atc-btn]', el);
    if (!v) {
      buttons.forEach(function (b) { b.disabled = true; });
      var t = $('[data-atc-text]', el);
      if (t) t.textContent = theme.strings.unavailable || 'No disponible';
      return;
    }
    this.variant = v;
    if (this.variantInput) this.variantInput.value = v.id;

    var price = $('[data-price]', el);
    if (price) price.textContent = formatMoney(v.price);
    var compare = $('[data-compare-price]', el);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (compare) { compare.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compare.hidden = !onSale; }
    var badge = $('[data-save-badge]', el);
    var wrap = $('[data-price-wrap]', el);
    if (badge && wrap) {
      if (onSale) {
        var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        var amt = formatMoney(v.compare_at_price - v.price);
        badge.textContent = (wrap.getAttribute('data-badge-template') || '').replace('[percent]', pct).replace('[amount]', amt);
      }
      badge.hidden = !onSale;
    }

    buttons.forEach(function (b) { b.disabled = !v.available; });
    var atc = $('[data-atc]', el);
    var atcText = $('[data-atc-text]', el);
    if (atc && atcText) atcText.textContent = v.available ? atc.getAttribute('data-label') : (theme.strings.soldOut || 'Agotado');

    this.updateBundlePrices();
    if (v.featured_media) this.goToMedia(v.featured_media.id);
    if (window.history && history.replaceState && !window.Shopify.designMode) {
      history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    }
  };

  ProductSection.prototype.initBundle = function () {
    if (!this.bundle) return;
    var self = this;
    var sync = function () {
      var checked = $('input[type="radio"]:checked', self.bundle);
      $$('.bundle__option', self.bundle).forEach(function (o) { o.classList.toggle('is-selected', !!checked && o.contains(checked)); });
      if (checked && self.qtyInput) self.qtyInput.value = checked.getAttribute('data-qty');
    };
    this.bundle.addEventListener('change', sync);
    if (!$('input[type="radio"]:checked', this.bundle)) {
      var first = $('input[type="radio"]', this.bundle);
      if (first) first.checked = true;
    }
    sync();
  };

  ProductSection.prototype.updateBundlePrices = function () {
    if (!this.bundle || !this.variant) return;
    var v = this.variant;
    var baseCompare = Math.max(v.compare_at_price || 0, v.price);
    $$('input[type="radio"]', this.bundle).forEach(function (r) {
      var opt = r.closest('.bundle__option');
      var q = parseInt(r.getAttribute('data-qty'), 10) || 1;
      var d = parseInt(r.getAttribute('data-discount'), 10) || 0;
      var total = Math.floor(v.price * q * (100 - d) / 100);
      var comp = baseCompare * q;
      var p = $('[data-bundle-price]', opt);
      var c = $('[data-bundle-compare]', opt);
      if (p) p.textContent = formatMoney(total);
      if (c) { c.textContent = formatMoney(comp); c.hidden = !(comp > total); }
    });
  };

  ProductSection.prototype.initQty = function () {
    var input = this.qtyInput;
    if (!input || input.type === 'hidden') return;
    this.el.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      if (e.target.closest('[data-qty-plus]')) input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  };

  ProductSection.prototype.initForm = function () {
    if (!this.form) return;
    var self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-atc]', self.form);
      var err = $('[data-form-error]', self.form);
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      if (err) err.hidden = true;

      var checked = self.bundle && $('input[type="radio"]:checked', self.bundle);
      var code = checked ? (checked.getAttribute('data-code') || '').trim() : '';
      var root = theme.routes.root || '/';
      var applyCode = code
        ? fetch(root.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {})
        : Promise.resolve();

      applyCode
        .then(function () {
          return fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(self.form)
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar al carrito');
            return data;
          });
        })
        .then(function () {
          if (theme.settings.goCheckout) {
            window.location.href = root.replace(/\/?$/, '/') + 'checkout';
            return;
          }
          if (!document.getElementById('CartDrawer') || document.body.classList.contains('template-cart')) {
            window.location.href = theme.routes.cart || '/cart';
            return;
          }
          return Cart.refresh(theme.settings.cartOpen !== false);
        })
        .catch(function (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        })
        .then(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = !(self.variant && self.variant.available); }
        });
    });
  };

  ProductSection.prototype.initSticky = function () {
    var bar = $('[data-sticky-atc]', this.el);
    if (!bar) return;
    var self = this;
    var target = $('[data-atc]', this.el) || $('.product-info', this.el);
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', show);
      }).observe(target);
    }
    var btn = $('[data-sticky-atc-btn]', bar);
    if (btn) btn.addEventListener('click', function () {
      if (self.form && self.variant && self.variant.available) {
        if (self.form.requestSubmit) self.form.requestSubmit();
        else self.form.dispatchEvent(new Event('submit', { cancelable: true }));
      } else {
        scrollToBuy();
      }
    });
  };

  function scrollToBuy() {
    var target = $('[data-bundle]') || $('[data-product-form]') || $('[data-product-section]');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-to-buy]');
    if (!a) return;
    if (!$('[data-product-section]')) return;
    e.preventDefault();
    scrollToBuy();
  });

  /* ---------------- Countdown ---------------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function storageGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function storageSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el._cd) return;
      el._cd = true;
      var mode = el.getAttribute('data-mode');
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 15;
      var end;
      var compute = function () {
        var now = new Date();
        if (mode === 'fixed') {
          end = new Date(el.getAttribute('data-end'));
          if (isNaN(end)) end = new Date(now.getTime() + 86400000);
        } else if (mode === 'evergreen') {
          var key = 'flowa_cd_' + minutes;
          var start = parseInt(storageGet(key), 10);
          if (!start || now.getTime() - start > minutes * 60000) {
            start = now.getTime();
            storageSet(key, start);
          }
          end = new Date(start + minutes * 60000);
        } else {
          end = new Date(now);
          end.setHours(24, 0, 0, 0);
        }
      };
      compute();
      var d = $('[data-cd-days]', el), h = $('[data-cd-hours]', el), m = $('[data-cd-minutes]', el), s = $('[data-cd-seconds]', el);
      var tick = function () {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (mode === 'fixed') {
            diff = 0;
            el.classList.add('is-ended');
            if (el.getAttribute('data-hide-on-end') === 'true') {
              var wrap = el.closest('.product-countdown');
              (wrap || el).hidden = true;
            }
          } else {
            compute();
            diff = Math.max(0, end - Date.now());
          }
        }
        var sec = Math.floor(diff / 1000);
        if (d) d.textContent = pad(Math.floor(sec / 86400));
        if (h) h.textContent = pad(Math.floor((sec % 86400) / 3600));
        if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
        if (s) s.textContent = pad(sec % 60);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------- Fecha de envío ---------------- */
  function initShipDates(root) {
    $$('[data-ship-date]', root).forEach(function (el) {
      var skipSun = el.getAttribute('data-skip-sunday') === 'true';
      var skipSat = el.getAttribute('data-skip-saturday') === 'true';
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      $$('[data-date-offset]', el).forEach(function (span) {
        var days = parseInt(span.getAttribute('data-date-offset'), 10) || 0;
        var date = new Date();
        if (!isNaN(cutoff) && date.getHours() >= cutoff) days++;
        var guard = 0;
        while (days > 0 && guard < 60) {
          guard++;
          date.setDate(date.getDate() + 1);
          var wd = date.getDay();
          if ((wd === 0 && skipSun) || (wd === 6 && skipSat)) continue;
          days--;
        }
        span.textContent = date.toLocaleDateString('es-CL', { day: 'numeric', month: 'long' });
      });
    });
  }

  /* ---------------- Auto slider (mini reseñas) ---------------- */
  function initAutoSliders(root) {
    $$('[data-autoslider]', root).forEach(function (el) {
      if (el._as) return;
      el._as = true;
      var slides = $$('[data-slide]', el);
      if (!slides.length) return;
      var i = 0, paused = false;
      slides[0].classList.add('is-active');
      if (slides.length < 2) return;
      var interval = parseInt(el.getAttribute('data-interval'), 10) || 4000;
      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------------- Videos ---------------- */
  function initVideos(root) {
    var autoVideos = $$('.video-media--autoplay video, .gallery__video[autoplay]', root);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      autoVideos.forEach(function (v) {
        v.muted = true;
        v.setAttribute('playsinline', '');
        io.observe(v);
      });
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-sound]');
    var media = e.target.closest('[data-video-media]');
    if (!media) return;
    var video = $('video', media);
    if (!video) return;
    if (btn || media.classList.contains('video-media--autoplay')) {
      e.preventDefault();
      video.muted = !video.muted;
      if (!video.muted) {
        // Silencia los demás videos
        $$('[data-video-media] video').forEach(function (other) {
          if (other !== video) { other.muted = true; var m = other.closest('[data-video-media]'); if (m) m.classList.remove('is-unmuted'); }
        });
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      }
      media.classList.toggle('is-unmuted', !video.muted);
    }
  });

  /* ---------------- Contadores de estadísticas ---------------- */
  function initCounters(root) {
    var els = $$('[data-count-to]', root);
    if (!els.length) return;
    var run = function (el) {
      var to = parseFloat(el.getAttribute('data-count-to')) || 0;
      var start = null, dur = 1600;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * eased);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.textContent = el.getAttribute('data-count-to'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Puntos para carruseles móviles ---------------- */
  function initSliderDots(root) {
    $$('[data-slider].slider-mobile', root).forEach(function (slider) {
      if (slider._dots) return;
      slider._dots = true;
      var items = slider.children;
      if (items.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'slider-dots';
      for (var i = 0; i < items.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () {
            slider.scrollTo({ left: items[idx].offsetLeft - slider.offsetLeft - 16, behavior: 'smooth' });
          });
        })(i);
        dots.appendChild(b);
      }
      slider.parentNode.insertBefore(dots, slider.nextSibling);
      var update = function () {
        var idx = 0, min = Infinity;
        for (var j = 0; j < items.length; j++) {
          var dist = Math.abs(items[j].getBoundingClientRect().left - slider.getBoundingClientRect().left - 16);
          if (dist < min) { min = dist; idx = j; }
        }
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === idx); });
      };
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------------- Init ---------------- */
  function init(root) {
    root = root || document;
    $$('[data-product-section]', root).forEach(function (el) { if (!el._product) new ProductSection(el); });
    initCountdowns(root);
    initShipDates(root);
    initAutoSliders(root);
    initVideos(root);
    initCounters(root);
    initSliderDots(root);
  }

  window.Shopify = window.Shopify || {};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Editor de temas: re-inicializa al editar secciones
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    if (slide) {
      $$('[data-slide]', slide.parentNode).forEach(function (s) { s.classList.remove('is-active'); });
      slide.classList.add('is-active');
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('#CartDrawer')) closeDrawers();
  });
})();
